import enControls from './en/controls.json';
import enGeneral from './en/general.json';
import enSearch from './en/search.json';
import enPrompts from './en/prompts.json';
import heControls from './he/controls.json';
import heGeneral from './he/general.json';
import heSearch from './he/search.json';
import hePrompts from './he/prompts.json';

export const en = {
    general: enGeneral,
    controls: enControls,
    search: enSearch,
    prompts: enPrompts,
};

export const he = {
    general: heGeneral,
    controls: heControls,
    search: heSearch,
    prompts: hePrompts,
};
